import React from 'react';
import { TextFieldWithPrefix, FieldProps, useFieldHelper } from 'framework/ui/field';
import { OPDateIcon } from 'framework/ui/mui-builder';
import { DATE_FORMAT, useDateService } from 'framework/utils';
import { MILESTONE_STATUS, OUTCOME_STATUS } from 'domain/shared/newProject';
import moment from 'moment';

const OriginalPlannedDateField = ({ initialPlannedDateSource, statusSource, props }: FieldProps) => {
  const { getValue: getOriginalPlannedDate } = useFieldHelper<string>({ source: initialPlannedDateSource });
  const { getValue: getStatus } = useFieldHelper<string>({ source: statusSource });

  const { datesDifference, getToday } = useDateService();

  const originalDate = getOriginalPlannedDate();
  const status = getStatus();
  const isCompleted = status === OUTCOME_STATUS.COMPLETED || status === MILESTONE_STATUS.REJECTED;

  const isDatePassed = () => {
    if (!originalDate) return false;
    return moment(originalDate).isBefore(getToday(), 'date');
  };

  const getTooltipTitle = () => {
    if (isCompleted) return 'Original planned date';
    return originalDate ? (
      <div style={{ textAlign: 'center' }}>
        Original planned date
        <br />
        {moment(originalDate).format(DATE_FORMAT.API_ONLY_DATE)}
      </div>
    ) : (
      'Original planned date'
    );
  };

  return (
    <TextFieldWithPrefix
      tooltipProps={{
        title: getTooltipTitle(),
        children: (
          <div>
            <OPDateIcon />
          </div>
        ),
      }}
      boxSx={{
        color: status === OUTCOME_STATUS.ACTIVE && isDatePassed() ? 'error.main' : 'text.primary',
      }}
      {...props}
      value={isCompleted ? originalDate : datesDifference(getToday(), originalDate)}
    />
  );
};
export default OriginalPlannedDateField;
